export default __webpack_public_path__ + "static/media/new_visitor.c4d96156.png";